export default "__VITE_ASSET__BAxck9Xm__"